@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@activitiesFooterHeight: 60px;

.activities {
  height: calc(100% - @activitiesFooterHeight);
  padding: 0 20px;
  overflow-y: auto;

  .item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 10px;
    border-bottom: 1px solid @settings-page--account-user-activity--border-color;
  }

  .timestamp {
    display: flex;
    align-items: center;

    .icon {
      margin-right: 5px;
      height: 15px;
      width: 15px;
    }
  }
}

.activity-footer {
  height: @activitiesFooterHeight;
  padding: 20px;
}

.empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
